export default __webpack_public_path__ + "static/media/computerp.2d481746.png";